/** スライダー値は画面上の消しゴム直径（px）。高解像度キャンバスへ描画するときは表示倍率で換算する。 */
export function brushDisplayToCanvasLineWidth(
  brushDisplayPx: number,
  canvasWidth: number,
  canvasHeight: number,
  displayWidth: number,
  displayHeight: number,
): number {
  if (brushDisplayPx <= 0) return 1;
  if (canvasWidth <= 0 || canvasHeight <= 0 || displayWidth <= 0 || displayHeight <= 0) {
    return brushDisplayPx;
  }
  const scaleX = canvasWidth / displayWidth;
  const scaleY = canvasHeight / displayHeight;
  const scale = (scaleX + scaleY) / 2;
  return Math.max(1, brushDisplayPx * scale);
}

export function brushDisplayDiameter(_brushDisplayPx: number): number {
  return _brushDisplayPx;
}
